const reducer = (state = {}, action) => {
  switch (action.type) {
    case "FETCH_NABL_LOGO":
      return action.payload;
    case "CLEAR_NABL_LOGO":
      return {};
    default:
      return state;
  }
};
export default reducer;
